import { render } from "./PageView.vue?vue&type=template&id=04887817&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-04887817"

export default script